import React, { useEffect, useState } from "react";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import {Card, CardBody,Modal,ModalHeader,Button,Label,Input} from "reactstrap";
import 'bootstrap/dist/css/bootstrap.min.css';
import Form from 'react-bootstrap/Form';
import FloatingLabel from 'react-bootstrap/FloatingLabel';
import Table from 'react-bootstrap/Table';
import {ToastContainer,toast} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { v4 as uuidv4 } from 'uuid';
import Axios from 'axios'
import { jsPDF } from 'jspdf';
import html2canvas from 'html2canvas';
import 'jspdf-autotable';


export default function ProductionReport() {
        const [agent, setAgent] = useState('')
        const [agentCode, setAgentcode] = useState('')
        const [extensions, setExtensions] = useState([])
        const [currentPage, setCurrentPage] = useState(1);
        const rowsPerPage = 20;
        const totalPages = Math.ceil(extensions.length / rowsPerPage);
        const indexOfLastRow = currentPage * rowsPerPage;
        const indexOfFirstRow = indexOfLastRow - rowsPerPage;
        const currentPolicies = extensions.slice(indexOfFirstRow, indexOfLastRow)
        const [monthStartMs, setMonthstartms] = useState(null)
        const[end,setEnd] = useState('');
        const[start,setStart] = useState('');
        const [currentMonthName,setCurrentmonthname] = useState(null)
        const [credentials, setCredentials] = useState(null)
        const [isAuth, setIsauth] = useState(false)
        const company = 'Definite'
        const [isPassword, setIspassword] = useState(false)
        const [code, setCode] = useState(null)
        const [gcode, setGcode] = useState('')
        const [phone, setPhone] = useState(null)
        const [modal, setModal] = useState(false)
        const [viewCode, setViewcode] = useState('View Commissions')
        const [resetCodetext, setResetcodetext] = useState('Reset your code')
    
        useEffect(()=>{
        const getCredentials =async()=>{
        const res = await fetch(`https://digitalapi.definiteassurance.com/api/getCredentials?username=${company}`)
        const data = await res.json();
        const {Username, Password} = data;
        const cred = btoa(`${Username}:${Password}`)
        setCredentials(btoa(`${Username}:${Password}`))
        setIsauth(true)
    
    
        }
        getCredentials()
    
        },[])

        const handleDateChange = (e) => {
            const dateTime = e.target.value;
            const millisecondsSinceEpoch = new Date(dateTime).getTime();
            setStart(millisecondsSinceEpoch);
            const date = new Date(millisecondsSinceEpoch);

            const monthName = date.toLocaleString('default', { month: 'long' });
            setCurrentmonthname(monthName)
        
        
          };
          const handleDateChange2 = (e) => {
            const dateTime = e.target.value;
            const millisecondsSinceEpoch = new Date(dateTime).getTime();
            setEnd(millisecondsSinceEpoch);
           
          };
 
        const exportTableToPDF = () => {
            const input = document.getElementById('policy-table');
            
            // Optional: Add a temporary title to the table before capturing
            const title = document.createElement('h2');
            title.textContent = `${currentMonthName} PRODUCTION REPORT`;
            title.style.textAlign = 'center';
            title.style.color = '#2c3e50';

            title.style.marginBottom = '20px';
            input.parentNode.insertBefore(title, input); // Insert title above table
          
            // Color the header row (if not already styled)
            const headerRow = input.querySelector('thead tr');
            headerRow.style.backgroundColor = 'green'; // Dark gray
            headerRow.style.color = 'white';
          
            html2canvas(input, {
              scale: 2, // Higher quality
              logging: false, // Disable console logs
              useCORS: true, // Handle external resources
              allowTaint: true, // Allow external images
            }).then((canvas) => {
              const imgData = canvas.toDataURL('image/png');
              const pdf = new jsPDF('p', 'mm', 'a4');
              
              // Margins (10mm on all sides)
              const margin = 10;
              const imgWidth = 210 - margin * 2; // A4 width minus margins
              const imgHeight = (canvas.height * imgWidth) / canvas.width;
              
              // Add title text directly to PDF (alternative approach)
              pdf.setFontSize(19);
              pdf.setTextColor(44, 62, 80); // #2c3e50
              pdf.text(`${currentMonthName} PRODUCTION REPORT`, 105, margin, { align: 'center' }); // Centered
              
              // Add table image with margins
              pdf.addImage(
                imgData, 
                'PNG', 
                margin, 
                margin + 10, // Extra space below title
                imgWidth, 
                imgHeight
              );
          
              pdf.save('production_report.pdf');
              
              // Clean up: Remove temporary title and header styling
              title.remove();
              headerRow.style.backgroundColor = '';
              headerRow.style.color = '';
            });
          };

        const getMonthName = (input) => {
            const date = input ? new Date(input) : new Date();
            return date.toLocaleString('default', { month: 'long' });
          };
        //   const currentMonthName = getMonthName(); // No argument → current month
          const customDate = new Date(2025, 7, 11).getTime(); // August 11, 2025 (in ms)
          const augustName = getMonthName(customDate); // "August"


        useEffect(() => {
            setMonthstartms(getCurrentMonthStartInMilliseconds())
        const user = localStorage.getItem('definiteagent'); // Retrieve email
        if (user) {
            
            setAgent(user)
        } else {
        
        }
        }, []);
    
        useEffect(()=>{
            const getAgentcode =async()=>{
                const res =await fetch(`https://digitalapi.definiteassurance.com/api/getDealerdetails?email=${agent}`,{
                     method:"GET",
                headers:{
                  'Authorization': `Basic ${credentials}`,
                  'Content-Type': "application/json"
                }
                });
                const data = await res.json();
                setAgentcode(data.OID)   
                 const cleaned = (data.Mobile).toString().replace(/\s+/g, '');
                 if (cleaned.startsWith('+254')) {
                    setPhone(cleaned.substring(1))
                   
                } else if (cleaned.startsWith('254')) {
                    setPhone(cleaned)
                } else if (cleaned.startsWith('07')) {
                    setPhone('254' + cleaned.substring(1))
                   
                } else if (cleaned.startsWith('7')) {
                   setPhone('254' + cleaned)
                    
                }
    
    
            }
            if(agent && isAuth){
                getAgentcode()
                setCurrentmonthname(getMonthName())
            }
        },[agent, isAuth])
    
        useEffect(()=>{
            const getExtensions =async()=>{
                const res = await fetch(`https://digitalapi.definiteassurance.com/api/getProduction?agent=${agentCode}`,{
                     method:"GET",
                headers:{
                  'Authorization': `Basic ${credentials}`,
                  'Content-Type': "application/json"
                }
                })
                const data = await res.json();
                console.log('Production data:', data);
                console.log('Agent code:', agentCode);
                console.log('monthStartMs:', monthStartMs);
                setExtensions(data)
            }
    
            if(agentCode && isAuth){
                getExtensions()
            }
    
        },[agentCode,isAuth])


        function formateDateISO(input){
            if(typeof input === 'string'){
                return input.split('T')[0]
            }
            else if (input instanceof Date){
                return input.toISOString().split('T')[0]
            }
            else{
                return ('')
            }
    
            throw new Error('Invalid input: Expected ISO String or Date Object')
        }
        function formatDateToMilliseconds(input) {
            if (typeof input === 'string') {
                // For ISO string, create Date object and get time
                return new Date(input).getTime();
            }
            else if (input instanceof Date) {
                // For Date object, directly get time
                return input.getTime();
            }
            
            throw new Error('Invalid input: Expected ISO String or Date Object');
        }


    
        function formatter(amount) {
            return amount.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
          }

          const getCurrentMonthStartInMilliseconds = () => {
            const now = new Date();
            const firstDayOfMonth = new Date(now.getFullYear(), now.getMonth(), 1);
            return firstDayOfMonth.getTime();
          };
        
      const totalCommission = currentPolicies.reduce(
        (sum, policy) => sum + (policy.GrossCommission || 0),
        0
      )


          const viewCommissions =async()=>{
            setViewcode('Please wait...')
            const res = await fetch(`https://digitalapi.definiteassurance.com/api/getGeneratedcode?agent=${agentCode}`,{
            method:"GET",
            headers:{
                'Authorization': `Basic ${credentials}`,
                'Content-Type': "application/json"
            }
            });
            const data = await res.json()
            setCode(data.code)
            if(data.new){
                const sendCode = await Axios.post(`https://sms.definiteassurance.com/webhook/d649cb06-3ad4-4298-ae27-e9b14f32d809`,{
                     MessageParameters: [
                        {
                        Number: [`${phone}`],
                        Text: `${data.code}`
                        }
                    ]
                    })
                toast.success('Code sent to your phone number')
            }
            setViewcode('View Commissions')
            setModal(!modal)
          }
    
    
            const resetCode =async()=>{
            setResetcodetext('Please wait...')
            const res = await fetch(`https://digitalapi.definiteassurance.com/api/Resetcode?agent=${agentCode}`,{
            method:"GET",
            headers:{
                'Authorization': `Basic ${credentials}`,
                'Content-Type': "application/json"
            }
            });
            const data = await res.json()
            setCode(data.code)
            if(data.new){
                const sendCode = await Axios.post(`https://sms.definiteassurance.com/webhook/d649cb06-3ad4-4298-ae27-e9b14f32d809`,{
                     MessageParameters: [
                        {
                        Number: [`${phone}`],
                        Text: `${data.code}`
                        }
                    ]
                    })
                toast.success('Code sent to your phone number')
            }
            setResetcodetext('Reset your code')
           
          }
    
    
          const verifyCode =async()=>{
            if(gcode == code){
                setIspassword(true)
                setModal(false)
            }
            else{
                toast.error('Incorrect code')
            }
          }
  return (
    <div>
         <div className="page-content">
            <ToastContainer />
        <Breadcrumbs title="Definite Assurance" breadcrumbItem={`PRODUCTION REPORT - ${currentMonthName}`} />
        <Card className="mini-stats-wid">
            <CardBody>
            <div className="flt">
            <div className="mb-4" id='mb'>
                <Label className="form-label">From date</Label>
                <Input
                    name="text"
                    className="form-control"
                    placeholder="Search order"
                    type="date"
                    onChange={handleDateChange}
                    // value={email}

                />
                
            </div>
            <div className="mb-4" id='mb'>
                <Label className="form-label">To date</Label>
                <Input
                    name="text"
                    className="form-control"
                    placeholder="Search order"
                    type="date"
                    onChange={handleDateChange2}
                    // value={email}

                />
                
            </div>

            </div>
               
                <hr />

                 <div style={{display:'flex',justifyContent:'space-between'}}>
                        <button 
                        onClick={exportTableToPDF}
                        style={{ 
                            padding: '8px 16px',
                            background: 'rgb(0, 96, 66)',
                            color: 'white',
                            border: 'none',
                            borderRadius: '4px',
                            cursor: 'pointer'
                        }}
                        >
                        Export to PDF
                        </button>

                         <Button color="primary" onClick={viewCommissions}>{viewCode}</Button>
                 </div>
                
                    <div className="table-responsive" style={{padding:'10px'}}>


                <Table striped bordered hover id="policy-table">
                <thead>
                    <tr>
                    <th scope="col">#</th>
                    <th scope="col">Date Done</th>
                    <th scope="col">Client</th>     
                    <th scope="col">Product</th>
                    <th scope="col">Registration</th>
                    <th scope="col">Commencement date</th>
                    <th scope="col">Expiry Date</th>
                    <th scope="col">Gross Premium</th>
                    <th scope="col">Premium Paid</th>
                    <th scope="col">Net Commission(KES)</th>

                    </tr>
                </thead>
                <tbody>
                    {currentPolicies.map((val, index) => {
                    // Calculate the correct index based on current page
                    const globalIndex = indexOfFirstRow + index;
                    
                    // Check if we should display this row based on date filters
                    const shouldDisplay = (start === '' && end === '') 
                        ? formatDateToMilliseconds(val.DateDone) > monthStartMs
                        : (formatDateToMilliseconds(val.DateDone) > start && formatDateToMilliseconds(val.DateDone) < end);
                    
                    if (!shouldDisplay) return null;
                    
                    return (
                        <tr key={val.OID}>
                        <td>{index + 1}</td>
                        <td>{formateDateISO(val.DateDone)}</td>
                        <td ><button className="tableButton" value={val.OID} >{val.Dealer_name}</button></td>
                        <td>{val.ProductDescription}</td>
                        <td>{val.Narration}</td>
                        <td>{formateDateISO(val.CommencementDate)}</td>
                        <td>{formateDateISO(val.ExpiryDate)}</td>
                        <td>{formatter(val.GrossPremium)}</td>
                        <td>{formatter(val.PaidAmount)}</td>
                        {isPassword &&
                             <td>{formatter(val.NetCommission)}</td>
                        }
                         {!isPassword &&
                             <td>****</td>
                        }
                        </tr>
                    );
                    })}
                </tbody>
                </Table>

                {/* Pagination controls */}
                <div className="d-flex justify-content-between align-items-center">
                <div>
                    Showing {indexOfFirstRow + 1} to {Math.min(indexOfLastRow, extensions.length)} of {extensions.length} entries
                </div>
                <div>
                    <button 
                    className="btn btn-sm btn-outline-primary mx-1"
                    onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))}
                    disabled={currentPage === 1}
                    >
                    Previous
                    </button>
                    
                    {Array.from({ length: totalPages }, (_, i) => i + 1).map(page => (
                    <button
                        key={page}
                        className={`btn btn-sm mx-1 ${currentPage === page ? 'btn-primary' : 'btn-outline-primary'}`}
                        onClick={() => setCurrentPage(page)}
                    >
                        {page}
                    </button>
                    ))}
                    
                    <button 
                    className="btn btn-sm btn-outline-primary mx-1"
                    onClick={() => setCurrentPage(prev => Math.min(prev + 1, totalPages))}
                    disabled={currentPage === totalPages}
                    >
                    Next
                    </button>
                </div>
                </div>
                </div>
                
            </CardBody>
        </Card>
        </div>

         <Modal isOpen={modal}>
            <ModalHeader>View Commissions</ModalHeader>
            <div className="modalContainer">
                    <FloatingLabel className='formInput2' controlId="floatingInputGrid" label="Your Secret Code" onChange={(e)=>{setGcode(e.target.value)}}>
                        <Form.Control  className='inputSearch' value={gcode}  type="text" placeholder="Your Secret Code" />
                </FloatingLabel>
                <Button color="success" onClick={verifyCode}>Verify</Button>
                <p style={{marginTop:'3%',color:'blue',cursor:'pointer'}} onClick={resetCode}>{resetCodetext}</p>
            </div>
        </Modal>
    </div>
  )
}
